import script from "./depositPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./depositPayment.vue?vue&type=script&setup=true&lang=js"

import "./depositPayment.vue?vue&type=style&index=0&id=1e7efafe&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7efafe"]])

export default __exports__